export default function USSupport() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
            <path
                d="M10.9516 4H5.80342C4.80742 4 4 4.80742 4 5.80342V10.9516C4 11.9476 4.80742 12.755 5.80342 12.755H10.9516C11.9476 12.755 12.755 11.9476 12.755 10.9516V5.80342C12.755 4.80742 11.9476 4 10.9516 4Z"
                stroke="#3F68E0"
                strokeWidth="1.6"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M10.9516 15.2422H5.80342C4.80742 15.2422 4 16.0496 4 17.0456V22.1938C4 23.1898 4.80742 23.9972 5.80342 23.9972H10.9516C11.9476 23.9972 12.755 23.1898 12.755 22.1938V17.0456C12.755 16.0496 11.9476 15.2422 10.9516 15.2422Z"
                stroke="#3F68E0"
                strokeWidth="1.6"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M22.154 4H17.0058C16.0098 4 15.2024 4.80742 15.2024 5.80342V10.9516C15.2024 11.9476 16.0098 12.755 17.0058 12.755H22.154C23.15 12.755 23.9574 11.9476 23.9574 10.9516V5.80342C23.9574 4.80742 23.15 4 22.154 4Z"
                stroke="#3F68E0"
                strokeWidth="1.6"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M22.1968 15.2422H17.0486C16.0526 15.2422 15.2452 16.0496 15.2452 17.0456V22.1938C15.2452 23.1898 16.0526 23.9972 17.0486 23.9972H22.1968C23.1928 23.9972 24.0002 23.1898 24.0002 22.1938V17.0456C24.0002 16.0496 23.1928 15.2422 22.1968 15.2422Z"
                stroke="#3F68E0"
                strokeWidth="1.6"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M6.79013 8.32948L7.88289 9.4222L9.96427 7.34082"
                stroke="#3F68E0"
                strokeWidth="1.6"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}
